import {switchAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/react'
import {remCalc} from '../../_utils'

// eslint-disable-next-line @typescript-eslint/unbound-method
const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(switchAnatomy.keys)

const baseStyle = definePartsStyle({
    // define the part you're going to style
    container: {
        borderRadius: 'full',
    },
    thumb: {
        background: 'background.base.elevated',
        boxShadow:
            '0 0 0 1px var(--border-neutral-highlight, #FFF) inset, 2px 2px 4px 0 var(--neutral-sm, rgba(19, 24, 58, 0.12))',
        borderRadius: 'full',
        width: remCalc(20),
        height: remCalc(16),
        position: 'relative',
        _before: {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: 'calc(50% - 3px)',
            transform: 'translateY(-50%)',
            width: '1px',
            height: '4px',
            borderRadius: 'full',
            background: 'background.accent.muted',
        },
        _after: {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: 'calc(50% + 2px)',
            transform: 'translateY(-50%)',
            width: '1px',
            height: '4px',
            borderRadius: 'full',
            background: 'background.accent.muted',
        },
    },
    track: {
        background: 'background.accent.default',
        width: remCalc(40),
        height: remCalc(20),
        p: remCalc(2),
        display: 'flex',
        alignItems: 'center',
    },
})

export const Switch = defineMultiStyleConfig({baseStyle})
